import type { PressImageProps } from './interfaces';
import styles from './PressImage.module.scss';
import Image from '../../Image/Image';
import Icon from '../../Icon/Icon';
import clsx from 'clsx';

const PressImage = ({
  image,
  assetLink,
  shadow = false,
  caption,
  ...imageProps
}: PressImageProps) => {
  // const data: ShareData = {
  //   text: shareData?.text || '',
  //   title: shareData?.title || image.name,
  //   url: shareData?.url || assetLink,
  // };

  return (
    <div>
      <div className={clsx(styles.base, { [styles.shadow]: shadow })}>
        <Image
          image={image}
          className={styles.image}
          fitCover
          {...imageProps}
        />

        <div className={styles.bar}>
          {/* <Share {...data} color={PressShareColor.White} /> */}
          <div />
          <a
            className={styles.download}
            href={assetLink}
            download={image.name}
            target="_blank"
            rel="noreferrer"
          >
            <Icon
              variant={'action/download'}
              size="iconSize24"
              className={styles.downloadIcon}
            />
            Herunterladen
          </a>
        </div>
      </div>
      {caption && (
        <figcaption className={styles.figcaption}>{caption}</figcaption>
      )}
    </div>
  );
};

export default PressImage;
